import { Button, Col, Row, Container } from '@microfrontends/react-components'
import { useContext } from 'react'
import { DbStar } from '../../../components/NumerologyV2/SVG'
import AppContext from '../../../context/AppContext'
import { EDevice } from '../../MainLayout'
import { TopTitleCss, H1 } from '../Numerology.css'

interface IProps {
	handleOpen?: () => void
}

export default function TopTitle({ handleOpen }: IProps) {
	const { t, breakpoint } = useContext(AppContext)
	return (
		<TopTitleCss>
			<Container>
				<Col>
					<H1>
						Tra cứu
						<br /> Nhân số học
						<br /> Review to <span>Renew</span>
						<DbStar className='title__cover' />
					</H1>
					{breakpoint !== EDevice.MOBILE ? (
						<Button
							type='primary'
							className='search_button'
							onClick={handleOpen}
						>
							{t('Tra cứu nhân số học')}
						</Button>
					) : null}
				</Col>
			</Container>
		</TopTitleCss>
	)
}
